import React, { Fragment, useState, useEffect } from "react";
import { Link , useParams, useNavigate} from "react-router-dom";
// import DatePicker from "react-datepicker";
import useRequests from "../../../utils/useRequests";
import "react-datepicker/dist/react-datepicker.css";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../../utils/Snackbars";
import {Typography, Grid, FormControl} from '@mui/material';
import DatePicker from "react-datepicker";
import calender from "../../../images/calender.png"

const EditOrgTicket = () => {
    const { t_id } = useParams(); 
    const navigate = useNavigate();
    const { getRequest, postRequest, putRequest } = useRequests(); // Your custom hook for making API calls
    const [formData, setFormData] = useState({
        e_id: "",
        e_t_id: "",
        u_id: "",
        ticket_quantity: "1",
        date: ""
    });
    const [AlertData, setAlertData] = React.useState({
           variant: '',
           message: '',
         });
       
         const resetAlertData = () => {
           setTimeout(() => {
             setAlertData((AlertData) => ({
               ...AlertData,
               variant: '',
               message: '',
             }));
           }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
         };

      function formatDateToUTC(dateString) {
      let date = new Date(dateString);
  
      let year = date.getFullYear();
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let day = String(date.getDate()).padStart(2, "0");
  
      return new Date(`${year}-${month}-${day}T00:00:00.000Z`).toISOString();
      }

    const validation1 = useFormik({
        enableReinitialize: true,
    
        initialValues: formData,
        validationSchema: Yup.object({
          e_id: Yup.string().required("Plsease select Event"),
          e_t_id: Yup.string().required("Plsease select Ticket Type"),
          u_id: Yup.string().required("Plsease select User"),
          ticket_quantity: Yup.number()
          .min(1, "Minimum 1 ticket required")
          .max(6, "Maximum 6 tickets allowed")
          .required("Please select Ticket quantity"),
          date: Yup.string().test(
            "required-if-duration-1",
            "Please select Date",
            function (value) {
              if (duration == 1) {
                return !!value; 
              }
              return true; 
            }
          ),
        }),
    onSubmit: async (values) => {
        // e.preventDefault();

        try {
            let submit1 = document.getElementById('submit1');
            submit1.disabled = true;
            submit1.textContent = ('Processing...');
            // Convert form data to JSON
            const jsonpar = JSON.stringify({
              e_id: values.e_id,
              e_t_id: values.e_t_id,
              u_id: values.u_id,
              ticket_quantity: values.ticket_quantity,
              date: values.date ? (formatDateToUTC(values.date)) : ""
            });

            // Make the POST request
            const res = await putRequest(`org-ticket-edit/${t_id}`, jsonpar);

            // Handle the response
            if (res && res.code === 200) {
                setFormData({
                  e_id: "",
                  e_t_id: "",
                  u_id: "",   
                  ticket_quantity: "",   
                  date: ""
                });
                navigate('/list-org-tickets',{
                    state:{variant: "success",
                        message: "Ticket assigned successfully!",}
                })
            } else {
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: res.message || "Failed to assign ticket.",
                  }));
                  resetAlertData();
            }
            submit1.disabled = false;
            submit1.textContent = ('Edit Ticket');
        } catch (error) {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: "An error occurred while assignint ticket",
              }));
              resetAlertData();
        }
    }
    });

    const [options, setOptions] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(); 
    const [eventStartDate, setEventStartDate] = useState(); 
    const [eventEndDate, setEventEndDate] = useState(); 

    const handleSelectChange = (event) => {
      validation1.setFieldValue("date", "");

      validation1.setFieldValue("e_id", event.target.value);
      setSelectedEvent(event.target.value); 

      const Event = events.filter((e) => event.target.value == e.e_id);

      setEventStartDate(Event[0].start_datetime)
      setEventEndDate(Event[0].end_datetime)

      let optionsData=[];
      if (Event[0].one_day_ticket) optionsData.push({ value: "1", label: "1 Day" });
      if (Event[0].ten_day_ticket) optionsData.push({ value: "10", label: "10 Days" });
      setOptions(optionsData)
      setduration(optionsData[0].value)

      const eventTicketType = alleventsTicketTypes.filter((type) => type.e_id == event.target.value && type.day_pass == optionsData[0].value);
      setParticularEventTicketType(eventTicketType)
      validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
      setSelectedTicketType(eventTicketType[0].e_t_id); 
    };

    const [selectedTicketType, setSelectedTicketType] = useState(); 
    const handleSelectChangeTicketType = (type) => {
      validation1.setFieldValue("e_t_id", type.target.value);
      setSelectedTicketType(type.target.value); 
    };

    const [duration, setduration] = useState("");
    const handleSelectChangeDuration = (duration) => {
      setduration(duration.target.value); 

      const eventTicketType = alleventsTicketTypes.filter((type) => type.e_id == selectedEvent && type.day_pass ==duration.target.value);
      setParticularEventTicketType(eventTicketType)
      validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
      setSelectedTicketType(eventTicketType[0].e_t_id); 
    };

    const [events, setEvents] = useState([]);
    const [alleventsTicketTypes, setAllEventsTicketTypes] = useState([]);
    const [particularEventTicketType, setParticularEventTicketType] = useState([]);

    const fetchEvents = async (ticketData) => {
      const response = await getRequest("event-list");
      if (response && response.code === 200) {
        let eventsData = [];
        response.data.data.forEach((element) => {
          if (element.status == "Enable") {
            eventsData.push(element);
          }
        });
        setEvents(eventsData);
        setAllEventsTicketTypes( response.data.eventTicketTypeData);

        validation1.setFieldValue("e_id", ticketData.e_id);
        setSelectedEvent(ticketData.e_id); 


        const ticketEvent = eventsData.filter((event) => event.e_id == ticketData.e_id);
        setEventStartDate(ticketEvent[0].start_datetime)
        setEventEndDate(ticketEvent[0].end_datetime)
        const ticketEventType = response.data.eventTicketTypeData.filter((eventType) => eventType.e_t_id == ticketData.e_t_id);


        let optionsData=[];
        if (ticketEvent[0].one_day_ticket) optionsData.push({ value: "1", label: "1 Day" });
        if (ticketEvent[0].ten_day_ticket) optionsData.push({ value: "10", label: "10 Days" });

        if(optionsData.length !==0){
          setOptions(optionsData)
          setduration(ticketEventType[0].day_pass)
  
          const eventTicketType = response.data.eventTicketTypeData.filter((type) => type.e_id == ticketData.e_id && type.day_pass ==ticketEventType[0].day_pass);
          setParticularEventTicketType(eventTicketType)
          validation1.setFieldValue("e_t_id", ticketData.e_t_id);
          setSelectedTicketType(ticketData.e_t_id);
          validation1.setFieldValue("ticket_quantity", ticketData.quantity);
          if(ticketEventType[0].day_pass=="1"){
            validation1.setFieldValue("date", new Date(ticketData.event_ticket_date));
          }

          validation1.setFieldValue("u_id", ticketData.u_id);
        }else{
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Tickets are not available',
          }));
        }
        
        } else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: 'Failed to fetch events',
        }));
      }
      resetAlertData();
    };


    const [selectedUser, setSelectedUser] = useState(""); 
    const handleSelectChangeUser = (user) => {
      validation1.setFieldValue("u_id", user.target.value);
      setSelectedUser(user.target.value); 
    };

    const [users, setUsers] = useState([]);
    const fetchUsers = async () => {
      const response = await getRequest("user-list"); // Replace "users" with the appropriate API endpoint
      // const response = resultData[0]
      if (response && response.code === 200) {
        let usersData = [];
        response.data.forEach((element) => {
          if (element.status == "Enable") {
            usersData.push(element);
          }
        });

        setUsers(usersData);
      } else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: 'Failed to fetch users',
        }));
      }
      resetAlertData();
    };

    const fetchOrgTicketsData = async () => {
        try {
            const response = await getRequest(`/org-ticket/${t_id}`);

            if (response && Array.isArray(response.data) && response.data.length > 0) {

                fetchEvents(response.data[0]);

            } else {
                console.error("No ticket data found in the response.");
            }
        } catch (error) {
            console.error("Error fetching ticket data:", error);
        }
    };

    useEffect(() => {
      fetchOrgTicketsData();
      fetchUsers();

      resetAlertData();
    }, []);

    return (
      <Fragment>
        <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
          <h2 className='text-black font-w700 mb-0'>Edit Ticket</h2>
        </div>

        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='basic-form'>
                {AlertData.message !== "" ? (
                  <Snackbars
                    variant={AlertData.variant}
                    message={AlertData.message}
                  />
                ) : (
                  ""
                )}
                <form>
                  <div className='row mb-3'>

                    
                  <div className="form-group mb-3 col-md-4 col-xs-12">
                    <label>Select User :</label>
                    <select
                      className={`form-control ${
                        validation1.touched.u_id && validation1.errors.u_id
                          ? "is-invalid"
                          : ""
                      }`}
                      name="u_id"
                      value={validation1.values.u_id}
                      onChange={handleSelectChangeUser}
                    >
                      <option value="">-- Select User --</option>
                      {users.map((user) => (
                        <option key={user.u_id} value={user.u_id}>
                          {user.phone}
                        </option>
                      ))}
                    </select>
                    {validation1.touched.u_id && validation1.errors.u_id && (
                      <div className="invalid-feedback">
                        {validation1.errors.u_id}
                      </div>
                    )}
                  </div>

                  <div className="form-group mb-3 col-md-4 col-xs-12">
                    <label>Select Event :</label>
                    <select
                      className={`form-control ${
                        validation1.touched.e_id && validation1.errors.e_id
                          ? "is-invalid"
                          : ""
                      }`}
                      name="e_id"
                      value={validation1.values.e_id}
                      onChange={handleSelectChange}
                    >
                      <option value="">-- Select Event --</option>
                      {events.map((event) => (
                        <option key={event.e_id} value={event.e_id}>
                          {event.name}
                        </option>
                      ))}
                    </select>
                    {validation1.touched.e_id && validation1.errors.e_id && (
                      <div className="invalid-feedback">
                        {validation1.errors.e_id}
                      </div>
                    )}
                  </div>


                  <div className="form-group mb-3 col-md-4 col-xs-12">
                    <label>Select Pass Duration :</label>
                    <select
                      name="duration"
                      onChange={handleSelectChangeDuration}
                      value={duration}
                      className={'form-control'}
                    >
                      {options.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group mb-3 col-md-4 col-xs-12">
                    <label>Select Ticket Type :</label>
                    <select
                      className={`form-control ${
                        validation1.touched.e_t_id && validation1.errors.e_t_id
                          ? "is-invalid"
                          : ""
                      }`}
                      name="u_id"
                      value={validation1.values.e_t_id}
                      onChange={handleSelectChangeTicketType}
                    >
                      <option value="">-- Select TicketType --</option>
                      {particularEventTicketType.map((ticketTypes) => (
                        <option key={ticketTypes.e_t_id} value={ticketTypes.e_t_id}>
                          {ticketTypes.type}
                        </option>
                      ))}
                    </select>
                    {validation1.touched.u_id && validation1.errors.u_id && (
                      <div className="invalid-feedback">
                        {validation1.errors.u_id}
                      </div>
                    )}
                  </div>
                  {duration==1?
                      <div className='form-group mb-3 col-md-4 col-xs-12'>
                        <Grid item xs={12}>
                        <FormControl fullWidth className='custom-select datepciker'>
                          <label>Select Date :</label>
                            <DatePicker 
                                className={`form-control ${validation1.touched.date && validation1.errors.date ? "is-invalid" : ""}`} 
                                inputMode="none" 
                                isClearable id="date-picker"  
                                name="date" 
                                selected={validation1.values.date} 
                                onChange={(date) => validation1.setFieldValue("date", date)} 
                                dateFormat="dd-MM-yyyy" 
                                placeholderText="DD-MM-YYYY" 
                                format="DD/MM/YYYY" 
                                minDate={new Date(Math.max(new Date().setHours(0, 0, 0, 0), new Date(eventStartDate)))}
                                maxDate={new Date(eventEndDate)}
                                autoComplete="off"
                                disableKeyboardNavigation
                            />
                            <img src={calender} className="calender-img" alt="" />
                            {validation1.touched.date && validation1.errors.date && (
                                <Typography className='lable-error'>{validation1.errors.date}</Typography>
                            )}
                        </FormControl>
                        </Grid>
                        </div>
                        :""
                    }

                <div className='form-group mb-3 col-md-4 col-xs-12'>
                      <label>Quantity:</label>
                      <input
                        type='number'
                        className={`form-control ${validation1.touched.ticket_quantity && validation1.errors.ticket_quantity ? 'is-invalid' : ''}`}
                        name="ticket_quantity"
                        placeholder="Please Select Quantity"
                        value={validation1.values.ticket_quantity || ''}
                        onChange={validation1.handleChange}
                        min="1"
                        max="6"
                        invalid={
                        validation1.touched.ticket_quantity && validation1.errors.ticket_quantity ? true : false
                        }
                        
                    />
                    {validation1.touched.ticket_quantity && validation1.errors.ticket_quantity ? (
                        <div className="invalid-feedback" >{validation1.errors.ticket_quantity}</div>
                    ) : null}
                    </div>
                  </div>
                  <button type='submit' className='btn btn-primary me-2'
                  id="submit1"onClick={(e) => {
                    e.preventDefault();
                    validation1.handleSubmit();
                    return false;
                  }}>
                  {('Edit Ticket')}
                  </button>
                  <Link to='/list-org-tickets' className='btn btn-light'>
                    Cancel
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
};

export default EditOrgTicket;